/**
 * @generated SignedSource<<f8e3ee60d7b580fd6d3897999733ac43>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbReturnPolicy_item$data = {
  readonly returnPolicy: {
    readonly buyerCopy: {
      readonly customizableDetailReturnCopy: {
        readonly htmlCopy: string | null;
      } | null;
      readonly returnPolicySection?: {
        readonly htmlCopy: string | null;
      } | null;
      readonly returnPolicySectionHeader: {
        readonly htmlCopy: string | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentType": "PdpRespSidebarBlurbReturnPolicy_item";
};
export type PdpRespSidebarBlurbReturnPolicy_item$key = {
  readonly " $data"?: PdpRespSidebarBlurbReturnPolicy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbReturnPolicy_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "htmlCopy",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbReturnPolicy_item",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "ReturnPolicy",
      "kind": "LinkedField",
      "name": "returnPolicy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReturnPolicyCopy",
          "kind": "LinkedField",
          "name": "buyerCopy",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "InlineCtaCopy",
              "kind": "LinkedField",
              "name": "returnPolicySectionHeader",
              "plural": false,
              "selections": (v0/*:: as any*/),
              "storageKey": null
            },
            {
              "condition": "afterDisplay",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "userCountryCode",
                      "variableName": "userCountryCode"
                    }
                  ],
                  "concreteType": "InlineCtaCopy",
                  "kind": "LinkedField",
                  "name": "returnPolicySection",
                  "plural": false,
                  "selections": (v0/*:: as any*/),
                  "storageKey": null
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "InlineCtaCopy",
              "kind": "LinkedField",
              "name": "customizableDetailReturnCopy",
              "plural": false,
              "selections": (v0/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "f9e8050554b1edabfeaa28685bfa7b08";

export default node;
